import { ExportToCsv } from 'export-to-csv'
import React, { useCallback, useMemo } from 'react'

import { GetCustomerOrdersQuery } from '../../../../graphql/camel'
import { csvDataFromOrders } from '../../../../lib/orders/export'
import { isNotNull } from '../../../../utils/collectionTools'
import Spacer from '../../../Spacer'
import Spinner from '../../../Spinner'
import EmptyHistory from '../EmptyHistory'
import HeaderWithSecondaryButton from '../HeaderWithSecondaryButton'
import LoadMore from '../LoadMore'
import ReorderItems from './ReorderItems'
import { CustomerOrdersTable } from './table'

const exportOptions = {
  filename: 'Order History',
  showLabels: true,
  headers: ['Date', 'Order No.', 'Ship to Addressee', 'Total', 'Status'],
}

const csvExporter = new ExportToCsv(exportOptions)

export interface CustomerOrdersPageContentProps {
  data: GetCustomerOrdersQuery | undefined
  loading: boolean
  onLoadMore: (() => Promise<unknown>) | undefined
}

const CustomerOrdersPageContent: React.VFC<CustomerOrdersPageContentProps> = ({
  data,
  loading,
  onLoadMore,
}) => {
  const orders = useMemo(
    () => data?.getCustomerOrders?.orders?.filter(isNotNull),
    [data?.getCustomerOrders?.orders],
  )
  const anyOrdersPresent = !!orders?.length

  const handleCsvExport = useCallback(() => {
    if (!orders) {
      return
    }
    csvExporter.generateCsv(csvDataFromOrders(orders))
  }, [orders])

  return (
    <div>
      <HeaderWithSecondaryButton
        buttonHidden={!anyOrdersPresent}
        buttonText="Export..."
        headerText="Order History"
        onClick={handleCsvExport}
      />
      <Spacer size={3} />
      {anyOrdersPresent ? (
        <div>
          <div>
            <CustomerOrdersTable orders={orders} urlFragment="orders" />
            {onLoadMore && (
              <LoadMore buttonText="Load More Orders" onLoadMore={onLoadMore} loading={loading} />
            )}
            <hr />
          </div>
          <div>
            <ReorderItems showFrequentItems={true} showRecentItems={false} />
          </div>
        </div>
      ) : loading ? (
        <Spinner loading />
      ) : (
        <EmptyHistory message="No order history at the moment." />
      )}
    </div>
  )
}

export default CustomerOrdersPageContent
